import { app } from '../../../../../../app';
import { Controller } from './bulk-verification-csv.controller';

app.component('companyUserDirectoriesManageGroupAccountsBulkVerificationCsv', {
    bindings: {
        connectionDetails: '<',
        companyId: '<',
        groupId: '<',
    },
    controller: Controller,
    templateUrl: require('./bulk-verification-csv.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/bulk-verification-csv/bulk-verification-csv.component.js